export enum LOGGER_SPACIAL_SYMBOL {
	APP_DETAIL = '详情页',
	APP_BUILD = '应用创建',
	APP_BUILD_FLOW = '节点应用创建',
	GALLERY = '美图页',
	PERSONAL = '个人主页',
	GALLERY_DETAIL = '美图详情页',
	FULL_SCREEN_IMAGE = '全屏图片',
	GLOBAL = '全局捕获',
	RESULT = '生成结果',
	I18N = '多语言',
	H5_GALLERY = 'h5_美图页',
	EVENT_LOGGER = '埋点',
	HOME_IMAGE = '首页Image',
	FILE_UPLOAD = '文件上传',
	NETWORK_ERROR = '网络错误',
	BUSINESS_ERROR = '业务内错误',
	PARAM_ERROR = '接口参数错误',
	GENERATE = '生图接口',
	POST_DETAIL = 'post详情页',
	UTIL = '工具函数',
	API = 'API定价页',
	PAY_PAGE = '购买页',
	PAYMENT = '支付',
	REMIX = 'remix',
	BASIC = '基础模块',
}
